import React, { useState, useEffect } from "react";
import { useRange } from "react-instantsearch";
import * as Slider from "@radix-ui/react-slider";
import Accordion from "../../../UI/Accordion/Accordion";
import "./CustomRangeSlider.scss";
import CustomRangeInput from "../RangeImput/CustomRangeInput";

// …

const CustomRangeSlider = (props) => {
    const { start, range, canRefine, refine } = useRange(props);
    const { min, max } = range;
    const { panelTitle, unit, attribute } = props;
    const [value, setValue] = useState([min, max]);

    const from = Math.max(min, Number.isFinite(start[0]) ? start[0] : min);
    const to = Math.min(max, Number.isFinite(start[1]) ? start[1] : max);

    const refineRange = (min, max) => {
        refine(min, max);
    };
    useEffect(() => {
        setValue([from, to]);
    }, [from, to]);

    let refinementContent = (
        <Accordion header={panelTitle}>
            <div
                className="custom-rangeslider"
                data-insights-filter={`${attribute}:${value}`}
            >
                <Slider.Root
                    className="slider-root SliderRoot"
                    min={min}
                    max={max}
                    value={value}
                    onValueChange={setValue}
                    onValueCommit={refine}
                    disabled={!canRefine}
                    step={1}
                >
                    <div className="slider-range-values-container">
                        {from} {unit} - {to} {unit}
                    </div>
                    <Slider.Track className="slider-track SliderTrack">
                        <Slider.Range className="slider-range SliderRange" />
                    </Slider.Track>
                    <Slider.Thumb className="slider-thumb SliderThumb" />
                    <Slider.Thumb className="slider-thumb SliderThumb" />
                </Slider.Root>
            </div>
            <CustomRangeInput
                attribute={attribute}
                minRange={range.min}
                maxRange={range.max}
                unit={unit}
                minVal={start[0] === -Infinity ? min : start[0]}
                maxVal={start[1] === Infinity ? max : start[1]}
                refineRange={refineRange}
            />
        </Accordion>
    );
    return <>{canRefine ? refinementContent : null}</>;
};
export default CustomRangeSlider;
